import React, { useState, useEffect } from "react";
import {
  Tab,
  Button,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { BasicDrawer } from "../../../components/Shared";
import {
  ListProductionForms,
  ProductionForm,
} from "../../../components/Admin/ProductionForms";
import { useAuth } from "../../../hooks";
import { Form } from "../../../api";
import { encrypt, decrypt } from "../../../utils/cryptoUtils";
import { useLocation, useNavigate } from "react-router-dom";

// `text` sale de las traducciones (t(key)) al renderizar, no acá — estos
// keys ("water", "effluent", etc.) ya existen en los .json de i18n.
const QUESTIONNAIRE_OPTIONS = [
  { key: "water",       value: "/admin/data/waterforms" },
  { key: "effluent",    value: "/admin/data/effluentforms" },
  // { key: "air",          value: "/admin/data/airemissionsforms" },
  { key: "energy",      value: "/admin/data/energyforms" },
  // { key: "envobjetives", value: "/admin/data/environmentalobjetives" },
  { key: "production",  value: "/admin/data/productionforms" },
  { key: "waste",       value: "/admin/data/wasteforms" },
  { key: "social",      value: "/admin/data/socialforms" },
  { key: "fuel",        value: "/admin/data/fuelsforms" },
];
import {
  hasPermission,
  isAdmin,
  isMaster,
  isEditor,
} from "../../../utils/checkPermission";
import "./ProductionForms.scss";
import { useLanguage, useSite } from "../../../contexts";

const formController = new Form();

export function ProductionForms() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const {
    accessToken,
    user: { role, site },
  } = useAuth();
  const [siteSelected, setSiteSelected] = useState(null);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
   const [configFormData, setConfigFormData] = useState([]);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const location = useLocation();

  const siteContext = useSite().site;

  useEffect(() => {
    (async () => {
      try {
        if (siteContext !== "") {
          setSiteSelected(siteContext);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [siteContext]);

  useEffect(() => {
    (async () => {
      try {
        if (site) {
          setSiteSelected(site);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [site]);

    useEffect(() => {
      (async () => {
        try {
            setLoading(true);
            if (siteSelected && siteSelected !== "" && siteSelected !=="undefined") {
              const response = await formController.getFormsBySite(
                accessToken,
                siteSelected,
                "production"
              );
              if (response.length > 0) {
                setConfigFormData(response[0]);
              }else{
                setConfigFormData({module:"production",site:siteSelected})
              }
              setLoading(false); 
              setReload(false);     
          }
        } catch (error) {
          console.error(error);
          setConfigFormData([]);
        }
      })();
    }, [siteSelected, accessToken, reload]);

  useEffect(() => {
    (async () => {
      try {
        if (location.state?.siteSelected) {
          setSiteSelected(decrypt(location.state.siteSelected));
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [location]);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          {siteSelected === null &&
          (isMaster(role) || (isAdmin(role) && !site)) ? (
            <div className="no-site-warning">
              <Icon name="warning sign" size="big" />
              <p>{t("select_company_site_from_header")}</p>
            </div>
          ) : (
            <ListProductionForms
              reload={reload}
              onReload={onReload}
              siteSelected={siteSelected}
              yearSelected={yearSelected}
              configFormData={configFormData}
              setReload={setReload}
            />
          )}
        </Tab.Pane>
      ),
    },
  ];

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  return (
    <>
      <div className="production-forms-page">
        <div className="production-page-header-wrapper">
          <div className="production-page-header">
            <Dropdown
              className="production-questionnaire-dropdown"
              options={QUESTIONNAIRE_OPTIONS
                .map((opt) => ({ ...opt, text: t(opt.key) }))
                .sort((a, b) => a.text.localeCompare(b.text, language))}
              selection
              onChange={(_, data) => navigate(data.value)}
              value="/admin/data/productionforms"
            />
            <div className="production-page-actions">
              {(siteSelected !== null || site) ? (
                <Dropdown
                  className="production-year-dropdown"
                  placeholder={t("select")}
                  options={years.map((year) => ({ key: year, text: year, value: year }))}
                  selection
                  onChange={(_, data) => setYearSelected(data.value)}
                  value={yearSelected}
                />
              ) : null}
            </div>
          </div>
          {(siteSelected !== null || site) && (isAdmin(role) || isEditor(role) || isMaster(role)) ? (
            <Button icon className="production-add-btn" onClick={onOpenCloseModal}>
              <Icon name="plus" />
            </Button>
          ) : null}
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicDrawer show={showModal} close={onOpenCloseModal}>
        <ProductionForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          year={yearSelected}
          siteSelected={siteSelected}
          configFormData={configFormData}
        />
      </BasicDrawer>
    </>
  );
}

